const USER_AGENT_MESSAGE = 'Tenemos un problema con tu navegador. Prueba desactivando extensiones de privacidad,'
    + ' cambiando de navegador o usando modo incógnito.';
export default USER_AGENT_MESSAGE;
